/**
 * Giá trị id báo cáo chọn trong đối chiếu số dư dvc
 */
export default {
  N01a_SDKP_DVDT_ND112020: 'N01a_SDKP_DVDT_ND112020',
  N02a_SDKP_DVDT_ND112020: 'N02a_SDKP_DVDT_ND112020_Update',
  ReportMS04: 'ReportMS04',
  CashInBankConfirmation: 'CashInBankConfirmation',
};
